/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
*/

import { Inject, Injectable } from '@angular/core';

/**
 * Angular service that injects our AngularJS onedrive service so that we can call function in Angular framework.
 */
@Injectable()
export class OnedriveAssetLibraryService {
  /**
   * Default constructor that injects our AngularJS onedrive service.
   *
   * @param BulbAssetLibraryOneDriveService AngularJS BulbAssetLibraryOneDriveService service.
   */
  constructor(@Inject('BulbAssetLibraryOneDriveService') private BulbAssetLibraryOneDriveService) {}

  /**
   * Calling this method make sure the all onedrive embed content are loaded correctly.
   * @param {Object} contentBlock Content Block Object.
   * @param {string} unitId Id Of unit
   */
  loadOneDriveFileEmbed(contentBlock, unitId: string) {
    const originalUrl = decodeURIComponent(contentBlock.originalUrl);
    if (contentBlock.blockType === 'EMBED' && originalUrl.indexOf('api.onedrive.com') !== -1) {
      // Extract the shareId from originaUrl.
      const shareId = (originalUrl.split('shares/')[1]).split('/root')[0];
      angular.forEach(document.getElementsByClassName('embed'), (embedBlock) => {
        if (embedBlock.getAttribute('bulb-block-id') === contentBlock.id) {
          const iFrame = embedBlock.getElementsByTagName('iframe');
          this.BulbAssetLibraryOneDriveService.updateOneDriveItemUrl(
            iFrame[0],
            shareId,
            unitId,
            contentBlock.id,
            embedBlock.children[0].innerHTML,
          );
        }
      });
    }
  }
}
